<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        @change="handleTableChange"> 
      </a-table>
    </a-spin>

    <template slot="footer">
      <a-button key="back" @click="handleCancel">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import moment from "moment"

  export default {
    name: "ProjectModal",
    data () {
      return {
        title:"操作",
        visible: false,
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },{title: '项目名称',
            align:"center",
            dataIndex: 'name',
          },{title: '项目地址',
            align:"center",
            dataIndex: 'addr',
          },{title: '客户名称',
            align:"center",
            dataIndex: 'customer',
          },{title: '联系人',
            align:"center",
            dataIndex: 'person'
          },{title: '联系电话',
            align:"center",
            dataIndex: 'personTel'
          }
        ],
        //数据集
        dataSource:[],
        projectId:null,
        loading:false,        
        confirmLoading: false,
        url: {
          list: "/project/project/listByUser",
        },
      }
    },
    created () {
    },
    methods: {
      loadData (pid){
        console.log("----" + pid); 
        this.visible = true;
        this.dataSource = [];
        this.projectId = pid;

        var params = {};//查询条件
        params.userid = pid;
        let _this = this;
        getAction(this.url.list,params).then((res)=>{
          if(res.success){
            this.dataSource = res.result;
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      
      handleCancel () {
        this.close()
      },
      handleTableChange(pagination, filters, sorter){
        //分页、排序、筛选变化时触发
        //console.log(sorter);
        //TODO 筛选
        //this.ipagination = pagination;
        this.loadData();
      },

    }
  }
</script>

<style scoped>

</style>